// extracted by mini-css-extract-plugin
export default {"infiniteScrollLoader":"Ofc_zZjP_sq2UT9vh_mT"};